import ChrPropTypes from './ChrPropTypes';

const PropsExtractor = {
  getForList (node, propList) {
    return this._computeAllProps(node, propList, true);
  },

  getForListFromObj (obj, propList) {
    return this._computeAllProps(obj, propList, false);
  },

  _computeAllProps (obj, propList, isHTML) {
    let allProps = {};
    new Map(Object.entries(propList)).forEach((propType, propName) => {
      let propValue = this._getPropValue(obj, propName, isHTML);
      if(this._shouldParseJson(propType, propValue))
        allProps[propName] = JSON.parse(propValue);
      else
        allProps[propName] = propValue;
    });
    return allProps;
  },

  _getPropValue (obj, propName, isHTML) {
    if(isHTML)
       return obj.dataset[propName.toLowerCase()];
    return obj[propName];
  },

  _shouldParseJson (propType, propValue) {
    return (propType === ChrPropTypes.object || propType === ChrPropTypes.array) && (Object.prototype.toString.call(propValue) === '[object String]');
  },

  modifyBooleans (allProps, propList) {
    Object.keys(allProps).forEach((key) => {
      if (propList[key] === ChrPropTypes.bool){
        allProps[key] = (allProps[key] === 'true' || allProps[key] === true)
      }
    })
    return allProps;
  }
}

export default PropsExtractor;